import React from 'react';
import striptags from 'striptags';
import autolinker from 'autolinker';
import parse from 'html-react-parser';

import Link from '../../../Link';

function ParsedMessage({ children: message, linkStyles }) {
  const messageWithoutHtml = striptags(message);

  if (noLinksInMessage(messageWithoutHtml)) {
    return <React.Fragment>{messageWithoutHtml}</React.Fragment>;
  }

  const messageWithATags = wrapLinksWithATags(messageWithoutHtml);
  const messageWithReactElementLink = replaceATagsWithReactElement(messageWithATags, linkStyles);

  return <React.Fragment>{messageWithReactElementLink}</React.Fragment>;
}

function wrapLinksWithATags(message) {
  return autolinker.link(message, {
    phone: false,
    email: false,
  });
}

function noLinksInMessage(messageWithoutHtml) {
  const matches = autolinker.parse(messageWithoutHtml, {
    phone: false,
    email: false,
  });
  return matches.length === 0;
}

function replaceATagsWithReactElement(messageWithHtmlLinks, styles) {
  return parse(messageWithHtmlLinks, {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.name === 'a') {
        const url = domNode.attribs.href;
        return (
          <Link href={url} key={url} {...styles}>
            {url}
          </Link>
        );
      }
    },
  });
}

export default ParsedMessage;



// WEBPACK FOOTER //
// ./src/js/widgets/Status/CarrierMessages/MessagesList/ParsedMessage.js